import { getFileIconByType, FileIconFont, MimeType } from "./..";
/**
 * @summary This function is used to determine the default thumbnail icon based on the mime type of the file
 * @param mimeType mime type of a file
 * @param shouldShowThumbnailForPdf boolean value that determines whether or not a thumbnail image should be displayed for pdf files
 * @param thumbnailUrl string value that determines thumbnail url of a file.
 * @returns default icon class name based on the mime type of the file
 */
export const getDefaultIconByFileType = (mimeType, shouldShowThumbnailForPdf, thumbnailUrl) => {
    if (mimeType === MimeType.APPLICATION_PDF && shouldShowThumbnailForPdf && thumbnailUrl) {
        return undefined;
    }
    else {
        return mimeType ? getFileIconByType(mimeType, thumbnailUrl) : FileIconFont.GENERIC;
    }
};
//# sourceMappingURL=GetDefaultIconByFileType.js.map